import { flowRight, curryRight } from 'lodash';

/**
 * Uses specified reducer to update slices of state
 * @param {[]} key state key slice to use for given reducer.
 * @param {function} reducer reducer to use for updates.
 */
export const sliceReducer =
  (key, reducer) =>
    (state, action) =>
      state.setIn(key, reducer(state.getIn(key), action));

/**
 * Returns a reducer that is a composition of reducers
 * @param {function[]} reducers array of reducers that will be given given state and action
 * @param {?object} initialState optional initial state
 */
export const composeReducers =
  (reducers = [], initialState) =>
    (state = initialState, action) =>
      flowRight(...reducers.map(reducer => curryRight(reducer, 2)(action)))(state);
